import React, { useContext, useState } from "react";
import { ResultsEventContext } from "@state/context/results";
import { openEventStatistics } from "@utils";
import classnames from "classnames";

export default function ResultsEventStatisticsButton() {
	const event = useContext(ResultsEventContext);
	const [isHover, setIsHover] = useState(false);

	if (
		event.source != null &&
		event.source.providerId != null &&
		event.source.providerId !== ""
	) {
		return (
			<td className="table--results__body__data table--results__body__data--stats">
				<button
					className="btn btn--link"
					type="button"
					onClick={() => {
						if (event?.source?.providerId == null) {
							console.error("Expected event source but got null");
							return;
						}
						openEventStatistics(event.source.providerId);
					}}
					onMouseEnter={() => setIsHover(true)}
					onMouseLeave={() => setIsHover(false)}
				>
					<i
						className={classnames("u-icon u-icon--sml", {
							"u-icon--action--stats--active": !isHover,
							"u-icon--action--stats--selected": isHover,
						})}
					/>
				</button>
			</td>
		);
	}

	return (
		<td className="table--results__body__data table--results__body__data--stats" />
	);
}
